<template>
  <div>
    <b-modal
      id="timeSlot"
      size=""
      centered
      hide-header
      modal-content-classes="cust-modal-ht-wo cust-overflow-y-grey flex justify-center"
      hide-footer
      class="overflow-y-hidden"
    >
      <div>
        <div class="text-xl mt-6 mb-2">
          <h2 class="font-bold fsize20 mt-8">Available time slots</h2>
        </div>
        <b-form-checkbox
          v-for="(item, index) in slots"
          :key="'index-' + index"
          button
          v-model="timeSlots"
          :value="item.value"
          size="md"
          button-variant="outline-primary"
          class="text-white mr-2 mb-2"
          >{{ item.value }}
        </b-form-checkbox>
        <button
          class="text-white px-8 py-2 fsize20 rounded-lg bg-primary mt-4 flex m-auto"
          @click="saveSlots"
        >
          Add Time
        </button>
      </div>
    </b-modal>
    <b-card class="bg-white">
      <h2 class="font-bold fsize20">Pause Account</h2>
      <div class="flex gap-4 mt-4">
        <label class="">(Pause Account for some duration time)</label>
        <b-form-checkbox
          class="switch"
          v-model="pauseToggle"
          type="checkbox"
          id="s1"
          switch
        />
      </div>
      <div class="mt-5" v-show="pauseToggle">
        <div class="flex gap-5">
          <div class="w-1/2">
            <label>Start Date</label>
            <b-form-input
              type="date"
              placeholder="Enter Start Date"
              required
              v-model="startDate"
              class=""
            ></b-form-input>
          </div>

          <div class="w-1/2">
            <label>End Date</label>
            <b-form-input
              type="date"
              v-model="endDate"
              placeholder="Enter End Date"
              required
            ></b-form-input>
          </div>
        </div>
      </div>
      <button
        class="text-white px-8 py-2 fsize20 rounded-lg bg-primary mt-4 flex m-auto"
        @click="savePause"
      >
        Save
      </button>

      <div>
        <h2 class="font-bold fsize20 mt-8">New Mobile Number</h2>
        <div class="flex gap-4">
          <p>+91 {{ volunteer[0].userId.mobile }}</p>
          <feather-icon
            icon="Edit2Icon"
            class="mr-1 w-3 h-2"
            @click="mToggler(mobileToggle)"
          ></feather-icon>
        </div>
        <div v-show="mobileToggle">
          <div class="flex gap-5">
            <div class="w-1/2">
              <label>Add New Mobile Number</label>
              <div class="input-group">
                <input
                  type="text"
                  placeholder="Enter New Number"
                  class="form-control"
                  v-model="newMobile"
                />
                <div class="input-group-append">
                  <button
                    class="text-white input-group-text bg-primary cursor-pointer"
                    @click="generateOTP('mobile')"
                    :disabled="newMobile === ''"
                  >
                    Generate OTP
                  </button>
                </div>
              </div>
            </div>
            <div class="w-1/2">
              <!-- <label>Verify New Number</label> -->
              <label>Mobile Number OTP</label>
              <b-form-input
                type="text"
                v-model="newMobileOTP"
                placeholder="OTP"
              ></b-form-input>
              <!-- <b-form-input type="text" placeholder="888888888"></b-form-input> -->
            </div>
          </div>
          <button
            class="text-white px-8 py-2 fsize20 rounded-lg bg-primary mt-5 flex m-auto"
            @click="verifyOTP('mobile')"
          >
            Save
          </button>
        </div>
      </div>
      <div>
        <h2 class="font-bold fsize20 mt-8">New Email ID</h2>
        <div class="flex gap-4">
          <p>{{ volunteer[0].userId.email }}</p>
          <feather-icon
            icon="Edit2Icon"
            @click="eToggler(emailToggle)"
            class="mr-1 w-3 h-2"
          ></feather-icon>
        </div>
        <div v-show="emailToggle">
          <div class="flex gap-5">
            <div class="w-1/2">
              <label>Add New Email ID</label>
              <div class="input-group">
                <input
                  type="text"
                  placeholder="Enter New Email"
                  class="form-control"
                  v-model="newEmail"
                />
                <div class="input-group-append">
                  <button
                    class="text-white input-group-text bg-primary cursor-pointer"
                    @click="generateOTP('email')"
                  >
                    Generate OTP
                  </button>
                </div>
              </div>
            </div>
            <div class="w-1/2">
              <!-- <label>Verify New Email ID</label> -->
              <label>Email OTP</label>
              <b-form-input
                type="text"
                v-model="newEmailOTP"
                placeholder="OTP"
              ></b-form-input>
              <!-- <b-form-input type="text" placeholder="888888888"></b-form-input> -->
            </div>
          </div>
          <button
            class="text-white px-8 py-2 fsize20 rounded-lg bg-primary mt-5 flex m-auto"
            @click="verifyOTP('email')"
          >
            Save
          </button>
        </div>
      </div>
      <div>
        <h2 class="font-bold fsize20 mt-8">Payment</h2>
        <div class="flex gap-4 mt-4">
          <label class="">Set Price (Free / Amount)</label>
          <b-form-checkbox
            v-model="priceToggle"
            type="checkbox"
            id="s2"
            switch
          />
        </div>
        <div class="flex gap-5 items-center" v-show="priceToggle">
          <div class="w-1/2">
            <b-form-group label="Add Amount">
              <b-form-input
                v-model="price"
                type="text"
                placeholder="Enter an amount..."
                class="w-full"
              ></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div>
          Additional discount for users on memberships :
          <!-- <p v-for="(values, key) in this.membershipDisc[0].membershipDisc">
            {{ key + " : " + values }}%
          </p> -->
        </div>
        <!-- <span>{{ this.membershipDisc[0].membershipDisc }}</span> -->
        <!-- <button class="text-white px-4 fsize22 rounded-lg bg-primary">
          Save
        </button> -->
        <button
          class="text-white px-8 py-2 fsize20 rounded-lg bg-primary mt-4 flex m-auto"
          @click="savePrice"
        >
          Save
        </button>
      </div>
      <div>
        <div class="text-xl mt-6 mb-2">
          <h2 class="font-bold fsize20 mt-8">Set Availability</h2>
        </div>
        <functional-calendar
          v-model="calendarData"
          :change-month-function="true"
          :change-year-function="true"
          :sundayStart="true"
          @dayClicked="getDate"
          :date-format="'dd-mm-yyyy'"
          :is-date-range="false"
          :is-date-picker="true"
          :configs="calendarConfigs"
          :markedDates="markedDates"
          :marked-dates="markedDates"
          ref="calendarData"
          class="z-ind1"
        >
        </functional-calendar>
        <button
          class="text-white px-8 py-2 fsize20 rounded-lg bg-primary mt-4 flex m-auto"
          @click="saveDate"
        >
          Save
        </button>
      </div>
    </b-card>
  </div>
</template>

<script>
import { BIconPencilFill } from "bootstrap-vue";
import { FunctionalCalendar } from "vue-functional-calendar";
import { mapState } from "vuex";

export default {
  data() {
    return {
      editToggle: false,
    };
  },
  components: {
    BIconPencilFill,
    FunctionalCalendar,
  },
  data() {
    return {
      pauseToggle: false,
      priceToggle: false,
      mobileToggle: false,
      emailToggle: false,
      price: 0,
      startDate: null,
      endDate: null,
      newMobileOTP: "",
      newEmailOTP: "",
      newEmail: "",
      newMobile: "",
      slots: [
        { text: "10:00am", value: "10:00am" },
        { text: "11:00am", value: "11:00am" },
        { text: "12:00pm", value: "12:00pm" },
        { text: "01:00pm", value: "01:00pm" },
        { text: "02:00pm", value: "02:00pm" },
        { text: "03:00pm", value: "03:00pm" },
        { text: "04:00pm", value: "04:00pm" },
        { text: "05:00pm", value: "05:00pm" },
        { text: "06:00pm", value: "06:00pm" },
      ],
      timeSlots: [],
      calendar: {},
      calendarData: {},
      dateTimeSlots: [],
      dateKey: "",
      calendarConfigs: {
        isMultipleDatePicker: true,
        isMultiple: true,
        // withTimePicker: true,
        markedDates: [],
        disabledDates: ["beforeToday"],
      },
      membershipDisc: [],
      removeSlots: [],
    };
  },
  methods: {
    mToggler(toggle) {
      this.mobileToggle = !toggle;
    },
    eToggler(toggle) {
      this.emailToggle = !toggle;
    },
    generateOTP(type) {
      if (type == "email") {
        if (this.newEmail) this.getOTP(type);
      } else if (type == "mobile") {
        if (this.newMobile) this.getOTP(type);
      }
    },
    async getOTP(type) {
      let payload;
      if (type == "email") {
        payload = {
          email: this.volunteer[0].userId.email,
          type: "ChangeEmail",
        };
      } else if (type == "mobile") {
        payload = {
          mobile: this.volunteer[0].userId.mobile,
          type: "ChangeMobileNo",
        };
      }
      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch("auth/generateOTP", payload);
        loader.close();
        if (data.code == 200) {
          this.$swal.fire({
            text: `OTP has been sent on ${type}, please verify`,
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      } catch (error) {
        loader.close();
        console.log(error);
        if ("Error") {
          this.$swal.fire({
            title: "Error",
            text: error.response.data.message,
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      }
    },
    async verifyOTP(type) {
      let payload = {};

      if (type == "email") {
        Object.assign(payload, {
          email: this.volunteer[0].userId.email,
          otp: this.newEmailOTP,
        });
      } else if (type == "mobile") {
        Object.assign(payload, {
          mobile: this.volunteer[0].userId.mobile,
          otp: this.newMobileOTP,
        });
      }
      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch("auth/VerifyOTP", payload);
        if (data.code == 200) {
          let payload2 = {
            volunteerId: this.volunteer[0]._id,
            userId: this.volunteer[0].userId._id,
          };
          if (type == "email") {
            Object.assign(payload2, { email: this.newEmail.trim() });
          } else if (type == "mobile") {
            Object.assign(payload2, { mobile: this.newMobile.trim() });
          }
          await this.$store.dispatch("respitecare/editvolunteer", payload2);
          this.$swal.fire({
            text: `Your ${type} is updated`,
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
        this.getVolunteer();
        loader.close();
      } catch (error) {
        loader.close();
        if ("Error") {
          this.$swal.fire({
            title: "Error",
            text: error.response.data.message,
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      }
    },
    async savePause() {
      let payload;
      try {
        if (this.pauseToggle) {
          if (this.startDate && this.endDate) {
            payload = {
              pauseAccount: {
                pause: true,
                from: this.startDate,
                to: this.endDate,
              },
            };
          } else {
            return this.$swal.fire({
              text: `Start and end dates are required`,
              icon: "error",
              confirmButtonText: "Okay",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
          }
        } else {
          console.log("else");
          payload = {
            pauseAccount: {
              pause: false,
              from: "",
              to: "",
            },
          };
        }
        const data = await this.$store.dispatch(
          "respitecare/pausevolunteer",
          payload
        );
      } catch (error) {
        console.log(error);
      }
    },
    reset() {
      this.newEmail =
        this.newEmailOTP =
        this.newMobile =
        this.newMobileOTP =
        this.price =
          "";
      this.mobileToggle = this.emailToggle = false;
    },
    async savePrice() {
      if (this.priceToggle) {
        if (this.price == "") return;
        this.price = +this.price;
      } else {
        this.price = 0;
      }

      try {
        let payload = {
          volunteerId: this.volunteer[0]._id,
          userId: this.volunteer[0].userId._id,
          price: this.price,
        };
        const data = await this.$store.dispatch(
          "respitecare/editvolunteer",
          payload
        );
        if (data.code === 200) {
          await this.getVolunteer();
          this.$swal.fire({
            text: `Details Updated`,
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }

        payload = {};
      } catch (error) {
        console.log(error);
      }
    },
    getDate(val) {
      // console.log(val);
      this.volunteer[0].dateTimeSlots.forEach((ele) => {
        if (val.date == ele.date) {
          this.timeSlots = ele.time;
        }
      });
      this.dateTimeSlots.push({ date: val.date, time: "" });
      this.dateKey = val.date;
      this.$bvModal.show("timeSlot");
    },
    async saveSlots() {
      try {
        this.volunteer[0].dateTimeSlots.forEach((ele) => {
          if (this.dateTimeSlots[0].date == ele.date) {
            this.removeSlots.push(ele._id);
          }
        });
        this.dateTimeSlots.forEach((ele) => {
          if (ele.date === this.dateKey) {
            ele.time = this.timeSlots;
          }
        });
        this.timeSlots = [];
        this.$bvModal.hide("timeSlot");
      } catch (error) {
        console.log(error);
      }
    },
    async saveDate() {
      try {
        let payload = {
          volunteerId: this.volunteer[0]._id,
          userId: this.volunteer[0].userId._id,
          dateTimeSlots: this.dateTimeSlots,
          removeSlots: this.removeSlots,
        };
        // console.log(payload);
        const data = await this.$store.dispatch(
          "respitecare/editvolunteer",
          payload
        );
        if (data.code === 200) {
          await this.getVolunteer();
          this.$swal.fire({
            text: `Details Updated!`,
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          this.init();
        }
      } catch (error) {
        console.log(error);
      }
    },
    init() {
      if (this.volunteer[0].price <= 0) {
        this.priceToggle = false;
      } else {
        this.priceToggle = true;
        this.price = this.volunteer[0].price;
      }

      if (this.volunteer[0].pauseAccount.pause) {
        this.pauseToggle = true;
        this.startDate = this.volunteer[0].pauseAccount.from;
        this.endDate = this.volunteer[0].pauseAccount.to;
      } else {
        this.pauseToggle = false;
      }
    },
    async getVolunteer() {
      await this.$store.dispatch("respitecare/get_volunteerbyuserid", {
        volunteerId: this.volunteer[0].userId._id,
      });
      this.reset();
      this.init();
    },
  },
  computed: {
    ...mapState("respitecare", {
      volunteer: "get_volunteerbyuserId",
      get_volbyid: "get_volbyid",
    }),
    ...mapState("services", { get_AllService: "get_AllService" }),
  },
  async mounted() {
    await this.getVolunteer();
    this.init();
    if (this.get_volbyid.hasOwnProperty("timeSlots")) {
      this.timeSlots = this.get_volbyid.timeSlots;
    }
    this.volunteer[0].dateTimeSlots.forEach((ele) => {
      this.calendarConfigs.markedDates.push(ele.date);
    });

    this.membershipDisc = this.get_AllService.result.filter(
      (ele) => ele.title === this.volunteer[0].service
    );
  },
};
</script>

<style>
.vfc-main-container {
  box-shadow: none;
  background: none;
  border-top: 1px solid #0000001c;
  border-bottom: 0px solid #00000024;
  border-radius: 0px;

  font-family: sans-serif !important;
}
.vfc-today {
  border: 1px solid #4f0a4b !important;
  background: #fff !important;
  color: #4f0a4b !important;
}
.vfc-week .vfc-day span.vfc-span-day.vfc-marked {
  background-color: #4f0a4b !important;
  color: #fff !important;
}
.vfc-marked {
  background-color: #4f0a4b !important;
  color: #fff !important;
}
</style>
